import { ALLPOST } from "./actionTypes";
import posts from "./initialPosts"

const postsReducer = (state = posts, action) => {

    state = JSON.parse(JSON.stringify(state));

    switch (action.type) {
        case ALLPOST:
            return posts;
        default:
            return state;
    }
}

export default postsReducer;